import React from 'react';
import Modal from 'react-bootstrap/Modal';

export default function ModalBodyViewer(props) {
  return (
    <Modal.Body {...props}>
      {props.children}
    </Modal.Body>
  )
}